'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createValues = require('../createValues');

var _createValues2 = _interopRequireDefault(_createValues);

var _immutable = require('../structure/immutable');

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _createValues2.default)(_immutable2.default);


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/immutable/values.js
// module id = 3079
// module chunks = 0